export default __webpack_public_path__ + "static/media/avatar14.53adc4ad.png";